import { connect } from "react-redux";
import { compose } from "recompose";
import { openWizard } from "src/modules/pairing/duck/actions";
import { withFrame } from "src/components/Frame/Context";
import { withApp } from "src/components/App/Context";

import Dashboard from "./Dashboard";
import { hasPremium } from "src/modules/auth/duck/selectors";
import { synchronizeCloudAccount } from "src/modules/auth/duck/epics";
import {
  getFamilyDevices,
  getOtherDevices
} from "src/modules/device/duck/selectors/index";
import {
  wasInDashboardBefore,
  getWhatsNewContentVersion
} from "src/duck/selectors";
import { enteredDashboard } from "src/duck/actions";
import withRouter from "src/routing/withRouter";

function mapStateToProps(state) {
  return {
    hasPremium: hasPremium(state),
    wasInDashboardBefore: wasInDashboardBefore(state),
    whatsNewContentVersion: getWhatsNewContentVersion(state),
    hasPairedDevices:
      getFamilyDevices(state).length > 0 || getOtherDevices(state).length > 0
  };
}

const enhance = compose(
  connect(mapStateToProps, {
    openWizard: () => openWizard({ initialStep: "manual-pairing" }),
    onFirstimeEnter: () => enteredDashboard(),
    synchronizeCloudAccount
  }),
  withRouter,
  withApp,
  withFrame
);

export default enhance(Dashboard);
